





















import {Component, Vue} from 'vue-property-decorator'

import {routes} from "@/router"
import notifications from "../lib/notifications";

@Component({
  components: {},
})
export default class App extends Vue {
  public drawer = null

  public menuItem = null

  public notifications: any = []

  public menu = routes.map((r: any) => {
    let rName = r

    while (!rName.name) {
      rName = rName.children[0]
    }

    return {
      name: r.meta.breadcrumb,
      route: rName.name,
      icon: r.meta.icon
    }
  })

  public popNotification() {
    if (this.notifications.length > 0) {
      setTimeout(() => {
        this.notifications.pop()
        this.popNotification()
      }, 3000)
    }
  }

  mounted() {
    notifications.registerListener((s: string, m: string) => {
      this.notifications.push({
        severity: s,
        message: m
      })
      this.popNotification()
    })
  }

  public openRoute(name: string) {
    this.$router.push({name})
  }

  get breadcrumbs() {
    let id = this.$route.params.id ? this.$route.params.id : ''
    let bag = this.$route.matched.filter((m: any) => {
      return !m.path.endsWith("/")
    }).map((m: any) => {
      let t = m.meta.to ? m.meta.to : m.name
      return {
        text: m.meta.breadcrumb.toUpperCase(),
        exact: true,
        to: {name: t}
      }
    })

    if (id) {
      bag[bag.length - 1].text = bag[bag.length - 1].text + " #" + id
    }
    if (!bag.find(x => x ? x.text === 'HOME' : false)) {
      bag.unshift({
        text: 'HOME',
        exact: true,
        to: {name: 'dashboard'}
      })
    }

    /*      if (this.$route.name != 'home') {
            bag.unshift({
              text: 'HOME',
              exact: true,
              to: {name: 'home'}
            })
          }*/
    return bag
  }
}
